export default __webpack_public_path__ + "static/media/sv44_en_jing_b3.318a8b8f.mp3";